module.exports = __webpack_public_path__ + "img/house.9240ff2f.svg";